export default "__VITE_ASSET__421e5a67__"